document.addEventListener('submit', async function(e) {
    if (window.bypassStaychillIntercept) return;

    const discountForm = e.target.closest('.rebuy-cart__discount-form');

    if (discountForm) {
        const discountInput = discountForm.querySelector('#rebuy-cart__discount-input');

        if (discountInput && discountInput.value.trim().toUpperCase() === 'STAYCHILL') {
            
            if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart) {
                const cart = Rebuy.Cart.cart;
                const variantId = 43831786176578;

                const subtotalWithoutMask = cart.items.reduce((total, item) => {
                    return parseInt(item.variant_id) === parseInt(variantId) ? total : total + item.line_price;
                }, 0);

                const maskAlreadyInCart = cart.items.some(item => parseInt(item.variant_id) === parseInt(variantId));

                if (subtotalWithoutMask >= 3500) {
                    
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    try {
                        if (!maskAlreadyInCart) {
                            await fetch('/cart/add.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
                            });
                            document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
                        }

                        const delay = maskAlreadyInCart ? 100 : 800; 
                        
                        setTimeout(() => {
                            window.bypassStaychillIntercept = true;
                            
                            const activeForm = document.querySelector('.rebuy-cart__discount-form');
                            if (activeForm) {
                                const applyBtn = activeForm.querySelector('button[type="submit"]');
                                if (applyBtn) applyBtn.click();
                            }
                            
                            setTimeout(() => {
                                window.bypassStaychillIntercept = false;
                            }, 500);

                        }, delay); 
                        
                    } catch (error) {
                        console.error('Error handling STAYCHILL gift:', error);
                    }
                } else {
                    console.log('Cart regular items subtotal is under $35. Skipping custom logic.');
                }
            }
        }
    }
}, true);

document.addEventListener('rebuy:cart.change', function(e) {
    if (!window.Rebuy || !Rebuy.Cart || !Rebuy.Cart.cart) return;

    const cart = Rebuy.Cart.cart;
    const variantId = 43831786176578;

    const maskItem = cart.items.find(item => parseInt(item.variant_id) === parseInt(variantId));

    if (maskItem) {
        const discountTags = document.querySelectorAll('.rebuy-cart__discount-tag-text');
        const hasStaychillCode = Array.from(discountTags).some(tag => tag.textContent.trim().toUpperCase() === 'STAYCHILL');

        if (hasStaychillCode && maskItem.quantity > 1) {
            
            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: maskItem.key, quantity: 1 })
            }).then(() => {
                document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
                console.log('Prevented multiple free masks. Quantity locked to 1.');
            });
            
            return;
        }

        if (hasStaychillCode) {
            const subtotalWithoutMask = cart.items.reduce((total, item) => {
                return parseInt(item.variant_id) === parseInt(variantId) ? total : total + item.line_price;
            }, 0);

            if (subtotalWithoutMask < 3500) {
                
                setTimeout(() => {
                    const tags = document.querySelectorAll('.rebuy-cart__discount-tag');
                    
                    tags.forEach(tag => {
                        const textNode = tag.querySelector('.rebuy-cart__discount-tag-text');
                        
                        if (textNode && textNode.textContent.trim().toUpperCase() === 'STAYCHILL') {
                            const removeBtn = tag.querySelector('.rebuy-cart__discount-tag-remove');
                            if (removeBtn) {
                                removeBtn.click();
                                console.log('Subtotal dropped below $35. Removed discount code.');
                            }
                        }
                    });
                }, 500); 
            }
        }
    }
});